import React from 'react'
import Responsive from '../../components/Responsive';
import { checkTranslation, conditionalWidth, translate } from '../../utils/useful';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import BottomSheet from '../../components/BottomSheet';
import HttpServices from '../../utils/Http.services';
import * as actions from '../../stores/actionsList';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import WorkflowViewer from './WorkflowViewer';


class AutomationTemplateSelect extends React.Component {
    state = {

        scratchOption: [
            { name: '{{lang}}Basic builder', image: '/assets/icons/useful/timeline.png', value: 'basic', description: 'This can be used for simple workflows which does not need braches. This type is easy to manage but it has some limitation. It can later be converted to advanced.' },
            { name: '{{lang}}Diagram builder', image: '/assets/icons/useful/diagram.png', value: 'advanced', description: 'This option gives you advanced diagram editor to implement advanced and complicated workflows. This option can not be converted to basic mode.' },
        ],

        templates: [
            { name: 'SEO Project Management', image: '/templates/SEO Project Management 1.png', description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Velit repudiandae, cum corrupti' },
            { name: 'Agency Management', image: '/templates/4395467_rBJ.png', description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptas saepe tempore ' },
            { name: 'Marketing team', image: '/templates/CleanShot 2022-07-14 at 12.33.20@2x.png', description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Velit repudiandae, cum corrupti' },
            { name: 'Agency Management', image: '/templates/4395467_rBJ.png', description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Velit repudiandae, cum corrupti' },
            { name: 'Agency Management', image: '/templates/4395467_rBJ.png', description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptas saepe tempore ' },
            { name: 'SEO Project Management', image: '/templates/SEO Project Management 1.png', description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Velit repudiandae, cum corrupti' },
            { name: 'Agency Management', image: '/templates/4395467_rBJ.png', description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptas saepe tempore ' },
            { name: 'Marketing team', image: '/templates/CleanShot 2022-07-14 at 12.33.20@2x.png', description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Velit repudiandae, cum corrupti' },
        ],
        hubTemplates: [],
    }


    componentDidMount() {
        this.init()

        this.props.setHeader({
            'toolbar': null,
            'showToolbar': false,
            'title': translate("Select workflow"),
            isPortal: true,
            doNotshowNotification: true,

            // topHeaderComponent: this.props.isCreateFrame ? this.topHeaderComponent : null,
            // headerIdentityComponent: this.headerIdentityComponent,
            backAction: () => this.props.lastStage()
        })

    }


    init = () => {

        // console.log(this.props.variables)
        let body = {
            appletHub: this.props.variables?.appletHub?._id ?? this.props.variables?.appletHub,
            type: 'workflow'
        }

        console.log(body)

        this.setState({ isLoadingHubTemplates: true })

        HttpServices.request('getAutomations', body, (fetchResult, fetchError) => {

            this.setState({ isLoadingHubTemplates: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            // console.log(fetchResult)

            this.setState({ hubTemplates: fetchResult.info })

        })
    }

    continueScratch = (item) => {

        let type = item.value

        let data = this.props.initData

        if (this.props.fieldKey) {

            data[this.props.fieldKey] = type
            data.workflowId = null


        } else {

            if (!data.collectionInfo) {
                data.collectionInfo = {}
            }
            data.collectionInfo.workflowMode = type
            data.collectionInfo.workflowId = null

        }

        this.props.setData(data, () => {

            this.props.continue('template')

        })

    }

    selectTemplate = () => {

        let type = this.state.selectedTemplateType
        let id = this.state.selectedTemplate._id

        let data = this.props.initData
        if (!data.collectionInfo) {
            data.collectionInfo = {}
        }
        data.collectionInfo.workflowMode = type
        data.collectionInfo.workflowId = id


        this.props.setData(data, () => {
            this.props.continue('template')
        })

    }

    openTemplate = (item, type) => {
        this.setState({ selectedTemplate: item, selectedTemplateType: type })
        this.bottomSheet.open()
    }



    render() {
        return (

            <div className='flexc flex-column w-100 h-100 scroll-no-scrollbar'>
                <div className='p-3 w-100' style={{ maxWidth: 800 }}>

                    <div className='px-3 pt-3 mb-3 ' style={{}}>
                        <h2 className=" text-semibig mb-0 color-dark-blue-1" >{translate('Select workflow type')}</h2>
                        {/* <p className="mt-1 text-small color-dark-blue-1 max-width-500" >{translate("You can start from scratch for start from a template.")}</p> */}

                        <p className="text-bold text-normal mb-0 color-dark-blue-1 mt-3" >{translate('From scratch')}</p>

                        <div className='mt-3 d-flex flex-wrap w-100 ' >



                            {this.state.scratchOption.map((item, index) => {
                                return (
                                    <Responsive className="d-flex" width={this.props.width} media={{ xs: '12', sm: '6', md: '50%', lg: "50%", xl: "50%" }} key={index}>
                                        <div className={"h-100 d-flex " + (conditionalWidth(this.props.width, { xs: 'w-100', sm: 'w-95' }))}>
                                            <button onClick={() => this.continueScratch(item)} className={'d-flex flex-column text-start mb-3 bg-white br-10 px-3 pt-3 pb-3 w-100 flex-1 hover-shadow transition-all'} style={{}}>
                                                <div className='d-flex flex-column flex-1'>
                                                    <div className='flex-1 flexc'>
                                                        <div className='d-flex  '>
                                                            <img src={item.image} style={{ aspectRatio: '5/3', width: 50, objectFit: 'contain' }} />
                                                        </div>
                                                        <div className=''>
                                                            <p className='text-small text-bold '>{checkTranslation(item.name)}</p>
                                                            <p className='text-smaller mt-1' style={{ lineClamp: '2', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', display: '-webkit-box', boxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' }}>{checkTranslation(item.description)}</p>
                                                        </div>
                                                    </div>
                                                    {/* <div className='pb-1 flexc mt-2'>
                                                        <p className='text-smaller  opacity-5'>{translate("Continue")}</p>
                                                        <div className='flexcc pt-1'>
                                                            <img src={'/assets/icons/tower/arrow-right.svg'} className=' opacity-5 rotate-0' width={16} />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </button>
                                        </div>
                                    </Responsive>
                                )
                            })}

                        </div>

                        <p className="text-bold text-normal mb-0 color-dark-blue-1 mt-3" >{translate('Hub Shared workflows')}</p>


                        <div className='mt-4 d-flex flex-wrap w-100' >

                            {/* <Responsive className="d-flex" width={this.props.width} media={{ xs: '12', sm: '6', md: '25%', lg: "25%", xl: "25%" }} >
                            <div className={"h-100 d-flex " + (conditionalWidth(this.props.width, { xs: 'w-100', sm: 'w-95' }))}>
                                <button onClick={() => this.continueScratch()} className={'d-flex flex-column text-start color-dark-blue-1 mb-3 bg-white br-10 px-3 pt-3 pb-2 w-100 flex-1 hover-shadow transition-all'} >
                                    <div className='d-flex flex-column flex-1'>
                                        <div className='flex-1'>
                                            <div className='d-flex mt-1 w-100'>
                                                <img src={'/templates/add-file.png'} width={"100%"} style={{ aspectRatio: '5/3', objectFit: 'contain' }} />
                                            </div>
                                            <div className='mt-3'>
                                                <p className='text-small text-bold '>{translate("Create From scratch")}</p>
                                                <p className='text-smaller mt-1'>{translate("Create a blank workflow, I will add the stages by my self")}</p>
                                            </div>
                                        </div>
                                        <div className='pb-1 flexc mt-2'>
                                            <p className='text-smaller  opacity-5'>{translate("Continue")}</p>
                                            <div className='flexcc pt-1'>
                                                <img src={'/assets/icons/tower/arrow-right.svg'} className=' opacity-5 rotate-0' width={16} />
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                         </Responsive> */}





                            {this.state.hubTemplates.map((item, index) => {
                                return (

                                    <Responsive className="d-flex" width={this.props.width} media={{ xs: '12', sm: '6', md: '33.33%', lg: "25%", xl: "25%" }} key={index}>
                                        <div className={"h-100 d-flex " + (conditionalWidth(this.props.width, { xs: 'w-100', sm: 'w-95' }))}>
                                            <button onClick={() => this.openTemplate(item, 'hubTemplate')} className={'d-flex flex-column text-start color-dark-blue-1 mb-3 bg-white br-10 px-1 pt-1 pb-3 w-100 flex-1 hover-shadow transition-all'} style={{}}>
                                                <div className='d-flex flex-column flex-1 w-100'>
                                                    <div className='flex-1 flex-column d-flex'>
                                                        <div className='d-flex  w-100 br-8 flex-1' style={{ border: '1px solid #f0f0f0' }}>
                                                            {/* <img src={item.image} width={"100%"} style={{ aspectRatio: '5/3', objectFit: 'contain' }} /> */}
                                                            <WorkflowViewer width={this.props.width} variables={this.props.variables} stages={item.stages} currentStage={null} />

                                                        </div>
                                                        <div className='mt-2 px-2' >
                                                            <p className='text-small text-bold '>{checkTranslation(item.name)}</p>
                                                            <div className='flexc'>
                                                                <div className='' style={{ color: '#007aff' }}>
                                                                    <p className='text-smaller text-bolder text-capitalize'>{checkTranslation(item.mode)}</p>
                                                                </div>
                                                            </div>

                                                            {/* <p className='text-smaller mt-1'>{checkTranslation(item.description)}</p> */}
                                                        </div>
                                                    </div>
                                                    {/* <div className='pb-1 flexc mt-2'>
                                                        <p className='text-smaller  opacity-5'>{translate("Learn more")}</p>
                                                        <div className='flexcc pt-1'>
                                                            <img src={'/assets/icons/tower/arrow-right.svg'} className=' opacity-5 rotate-0' width={16} />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </button>
                                        </div>
                                    </Responsive>
                                )
                            })}
                        </div>





                        <p className="text-bold text-normal mb-0 color-dark-blue-1 mt-3" >{translate('Yonnect World Templates')}</p>


                        <div className='mt-4 d-flex flex-wrap w-100' >

                            {this.state.templates.map((item, index) => {

                                return (

                                    <Responsive className="d-flex" width={this.props.width} media={{ xs: '12', sm: '6', md: '33.3%', lg: "25%", xl: "25%" }} key={index}>
                                        <div className={"h-100 d-flex " + (conditionalWidth(this.props.width, { xs: 'w-100', sm: 'w-95' }))}>
                                            <button onClick={() => this.openTemplate(item, 'yonnectTemplate')} className={'d-flex flex-column text-start color-dark-blue-1 mb-3 bg-white br-10 px-3 pt-3 pb-2 w-100 flex-1 hover-shadow transition-all'} style={{}}>
                                                <div className='d-flex flex-column flex-1'>
                                                    <div className='flex-1'>
                                                        <div className='d-flex mt-1 w-100'>
                                                            <img src={item.image} width={"100%"} style={{ aspectRatio: '5/3', objectFit: 'contain' }} />
                                                        </div>
                                                        <div className='mt-3'>
                                                            <p className='text-small text-bold '>{checkTranslation(item.name)}</p>
                                                            <p className='text-smaller mt-1'>{checkTranslation(item.description)}</p>
                                                        </div>
                                                    </div>
                                                    <div className='pb-1 flexc mt-2'>
                                                        <p className='text-smaller  opacity-5'>{translate("Learn more")}</p>
                                                        <div className='flexcc pt-1'>
                                                            <img src={'/assets/icons/tower/arrow-right.svg'} className=' opacity-5 rotate-0' width={16} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </Responsive>
                                )
                            })}
                        </div>

                    </div>
                </div>

                <BottomSheet ref={el => this.bottomSheet = el} width={this.props.width}>
                    <div>
                        <div className='bg-gray-1  pt-3' style={{ marginTop: -20 }}>
                            <div className='px-4 flexcb'>
                                <div className='flexc'>
                                    <img src={this.state.selectedTemplate?.image} height={40} />
                                    <div className='mx-3'>
                                        <p className="text-bold text-normal mb-0 color-dark-blue-1" >{checkTranslation(this.state.selectedTemplate?.name)}</p>
                                        <div style={{ maxWidth: 450 }}>
                                            <p className="mt-0 text-small color-dark-blue-1" >{translate('ca.Select the applet they you want to continue with')}</p>
                                        </div>
                                    </div>
                                </div>


                                <ButtonAnimated
                                    onClick={() => this.selectTemplate()}
                                    title={translate("ca.Continue")}
                                    icon={'/assets/icons/angle-right-white2.svg'}
                                    imgWidth={'25px'}
                                    bg='linear-gradient(45deg, rgb(97, 0, 255) 51%, rgb(0, 148, 255) 100%)'
                                    textColor='#fff'
                                    language={this.props.language}
                                />

                            </div>

                            <div className='px-4 mt-3 '>
                                <button className='color-blue-1 text-normal mrd-4 pb-2' style={{ borderBottom: '1px solid #1379FF' }}><p className='text-small'>{translate('ca.Details')}</p></button>
                                <button className='color-dark-blue-1 text-normal mrd-4 pb-2' style={{ borderBottom: '1px solid transparent' }}><p className='text-small'>{translate('ca.Reviews')}</p></button>
                                <button className='color-dark-blue-1 text-normal mrd-4 pb-2' style={{ borderBottom: '1px solid transparent' }}><p className='text-small'>{translate('ca.Technical')}</p></button>


                            </div>
                        </div>
                        <div className='px-4 d-flex flex-wrap pt-4'>
                            <Responsive width={this.props.width} media={{ xs: '12', md: '8', lg: "8", xl: "8" }} >
                                <div className={'' + (conditionalWidth(this.props.width, { xs: 'prd-0', md: 'prd-4' }))}>
                                    <p className='text-normal text-bold mb-2'>{translate('ca.Description')}</p>
                                    <p className='text-small '>{translate('Lorem ipsum, dolor sit amet consectetur adipisicing elit. Laboriosam, alias ratione. Repellat, voluptatibus doloribus adipisci, a ipsam dicta maiores impedit temporibus voluptas harum necessitatibus eum quasi? Assumenda illum dicta sint!')}</p>
                                </div>
                            </Responsive>

                            <Responsive width={this.props.width} media={{ xs: '12', md: '4', lg: "4", xl: "4" }} >
                                <div className={'bb-1 pb-2 mb-2 flexcb ' + (conditionalWidth(this.props.width, { xs: 'mt-4', md: 'mt-0' }))}>
                                    <p className='text-small'>{translate("ca.Created By")} </p>
                                    <p className='text-bold text-small'>{translate('ca.Yonnect team')}</p>
                                </div>

                                <div className='bb-1 pb-2 mb-2 flexcb'>
                                    <p className='text-small'>{translate("ca.Tags")} </p>
                                    <p className='text-smaller tag-style px-2 py-1'>{translate('ca.University')}</p>
                                </div>

                            </Responsive>

                        </div>

                    </div>
                </BottomSheet>




            </div>
        )
    }
}

// export default AutomationTemplateSelect;
const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(AutomationTemplateSelect);